"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.FilterControl = void 0;
// external
const _ = require("lodash");
const React = require("react");
// css
const styles = require("./styles.scss");
const cssComposer_1 = require("../../../../helpers/cssComposer");
const css = (0, cssComposer_1.default)(styles, "FilterControl");
/**
 * This component renders out a list of available filters as provided through props.
 */
const FilterControl = ({ values, selectedValue, onClick, condensed }) => {
    if (onClick && !_.isFunction(onClick)) {
        throw new Error("onClick callback must be a function");
    }
    const isStringArray = Array.isArray(values) && values.length > 0 && typeof values[0] === "string";
    const stdValues = isStringArray
        ? values.map(v => ({
            value: v
        }))
        : values;
    return (React.createElement("div", { className: css(""), "data-test": "filter-control" }, stdValues.map((v, i) => (React.createElement("div", { key: i, className: css("filter", `-state-${v.state}`, {
            "-active": selectedValue === v.value,
            "-condensed": !!condensed
        }), onClick: () => onClick && onClick(v.value), "data-test": `filter-control-${i}`, "data-test-active": selectedValue === v.value ? "active" : "inactive" },
        !condensed && React.createElement("span", { className: css("filter_decoration") }),
        React.createElement("span", { "data-test": "filter-value", className: css("filter_label") }, v.value))))));
};
exports.FilterControl = FilterControl;
exports.default = exports.FilterControl;
//# sourceMappingURL=index.js.map